import Vue from 'vue'
import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'

import {
    FontAwesomeIcon
} from '@fortawesome/vue-fontawesome'
import {
    library
} from '@fortawesome/fontawesome-svg-core'

// solid
import {
    faClock,
    faPlus,
    faSearch,
    faSync,
    faSlidersH,
    faUsers,
    faChevronLeft,
    faChevronRight,
    faDownload,
    faCalendar,

    faReply,
    faShare,
    faBold,
    faItalic,
    faStrikethrough,
    faUnderline,
    faCode,
    faParagraph,
    faHeading,
    faListUl,
    faListOl,
    faTasks,
    faDotCircle,
    faQuoteRight,
    faPhotoVideo,
    faCheckSquare,
    faExternalLinkAlt,
} from '@fortawesome/free-solid-svg-icons'
import {
    faExternalLink,
    faUsersClass,
    faBallotCheck,
    faChevronDoubleLeft,
    faChevronDoubleRight,

    faH1,
    faH2,
    faH3,
//    faH4,
    faText,
} from '@fortawesome/pro-solid-svg-icons'
import {
    faCommentAltLines,
} from '@fortawesome/pro-regular-svg-icons'

library.add(
    // free-solid
    faClock,
    faPlus,
    faSearch,
    faSlidersH,
    faSync,
    faUsers,
    faChevronLeft,
    faChevronRight,
    faDownload,
    faCalendar,

    faReply,
    faShare,
    faBold,
    faItalic,
    faStrikethrough,
    faUnderline,
    faCode,
    faParagraph,
    faHeading,
    faListUl,
    faListOl,
    faTasks,
    faDotCircle,
    faQuoteRight,
    faPhotoVideo,
    faCheckSquare,
    faExternalLinkAlt,

    // pro-solid
    faExternalLink,
    faUsersClass,
    faBallotCheck,
    faText,
    faChevronDoubleLeft,
    faChevronDoubleRight,

    faH1,
    faH2,
    faH3,
//    faH4,

    // pro-regular
    faCommentAltLines
)

Vue.component('font-awesome-icon', FontAwesomeIcon)

const requireComponent = require.context(
    './',
    false,
    /Base[A-Z]\w+\.(vue|js)$/
)

requireComponent.keys().forEach(fileName => {
    const componentConfig = requireComponent(fileName)

    const componentName = upperFirst(
        camelCase(
            fileName
                .split('/')
                .pop()
                .replace(/\.\w+$/, '')
        )
    )

    Vue.component(
        componentName,
        componentConfig.default || componentConfig
    )
})
